import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

import UserSearch from '@/shared/components/input/UserSearch';
import EmployeeTagMultiSelect from '@/modules/hrm/EmployeeTagMultiSelect';
import TeamMultiSelect from '@/shared/components/input/multiselect/TeamMultiSelect';
import CompanyMultiSelect from '@/shared/components/input/multiselect/CompanyMultiSelect';
import LegalEntityMultiSelect from '@/shared/components/input/multiselect/LegalEntityMultiSelect';
import { hasMultipleCompanies } from '@/shared/components/security/HasMultiCompany';
import HasMultipleLegalEntities from '@/shared/components/security/HasMultipleLegalEntities';
import SavedFiltersButton from '@/shared/components/SavedFiltersButton';

import messages from '../hrmMessages';


export const defaultFilters = {
  employeeId: undefined,
  employeeProfile: undefined,
  withEmployeeLabels: [],
  ownCompanies: [],
  legalEntities: [],
  profileId: null,
  teams: [],
};

class EmployeeRelationMatrixFilters extends Component {
  filterChanged = filter => {
    const { filters, onFilterChange } = this.props;
    const newFilters = { ...filters, ...filter };

    if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
      onFilterChange(newFilters);
    }
  };

  render() {
    const { filters, columns, intl, employeeProfiles, onFilterChange, showEmployeeAndRoleFilters } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <EmployeeTagMultiSelect
                value={filters.withEmployeeLabels || []}
                onChange={val => this.filterChanged({ withEmployeeLabels: val })}
                placeholder={intl.formatMessage(messages.EmployeeLabels)}
              />
            </div>
          </div>
          {hasMultipleCompanies() && (
            <div className="col-lg-3 col-md-6">
              <div className="form-group">
                <CompanyMultiSelect
                  selection={filters.ownCompanies || []}
                  onChange={val => this.filterChanged({ ownCompanies: val })}
                />
              </div>
            </div>
          )}
          <HasMultipleLegalEntities>
            <div className="col-lg-3 col-md-6">
              <div className="form-group">
                <LegalEntityMultiSelect
                  selection={filters.legalEntities || []}
                  onChange={val => this.filterChanged({ legalEntities: val })}
                />
              </div>
            </div>
          </HasMultipleLegalEntities>
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <select
                className="form-control"
                value={filters.profileId || ''}
                onChange={e => this.filterChanged({ profileId: e.target.value || null })}
              >
                <option value="">{intl.formatMessage(messages.AllEmployeeProfiles)}</option>
                {(employeeProfiles || []).map(profile => (
                  <option key={profile.id} value={profile.id}>
                    {profile.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="form-group">
              <TeamMultiSelect
                selection={filters.teams || []}
                onChange={val => this.filterChanged({ teams: val })}
              />
            </div>
          </div>
        </div>
        {showEmployeeAndRoleFilters && (
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="form-group">
                <UserSearch
                  emptyLabel="All employees"
                  onChange={v => this.filterChanged({ employeeId: v?.id })}
                  value={filters.employeeId}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="form-group">
                <select
                  className="form-control"
                  value={'' + filters.employeeProfile}
                  onChange={e => this.filterChanged({ employeeProfile: e.target.value })}
                >
                  <option value="">{intl.formatMessage(messages.AllEmployeeRoles)}</option>
                  {columns.map(c => (
                    <option key={c.id} value={c.id}>
                      {c.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-lg-12">
            <SavedFiltersButton
              screen={this.props.screen || 'AssignmentAnalysisRelation'}
              currentFilters={filters}
              defaultFilters={this.props.defaultFilters || defaultFilters}
              onFiltersChanged={onFilterChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

EmployeeRelationMatrixFilters.propTypes = {
  intl: intlShape.isRequired,
  filters: PropTypes.shape({
    employeeId: PropTypes.string,
    employeeProfile: PropTypes.string,
    withEmployeeLabels: PropTypes.arrayOf(PropTypes.string),
    ownCompanies: PropTypes.arrayOf(PropTypes.string),
    profileId: PropTypes.string,
    teams: PropTypes.arrayOf(PropTypes.string),
  }),
  onFilterChange: PropTypes.func.isRequired,
  employeeProfiles: PropTypes.array,
  columns: PropTypes.array,
  showEmployeeAndRoleFilters: PropTypes.bool,
  screen: PropTypes.string,
};

EmployeeRelationMatrixFilters.defaultProps = {
  filters: { ...defaultFilters },
  employeeProfiles: [],
  showEmployeeAndRoleFilters: true,
};
export default injectIntl(EmployeeRelationMatrixFilters);
